import React, { useState,useRef, useEffect } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  Button,
  TextField,
  RadioGroup,
  Radio,
  FormControl,
  FormLabel,
  Grid,
  styled,
  Modal
} from "@mui/material";
import Swal from 'sweetalert2'
import { FileUploader } from "react-drag-drop-files";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import BSstyles from "./ActivateFnO.module.css";
import Grid2 from "@mui/material/Unstable_Grid2";
// import Secure from "../../assets/svg/Secure.svg";
import omImg from "../../assets/svg/oneMoney.png";
// import icon from "../../assets/svg/safe.svg"
import { useAppData } from "../../redux/appDataProvider";
import * as CryptoJS from "crypto-js";
import AppConfig from "../../AppConfig";
import ApiClient from "../../utilities/apiClient";
import MyLodder from "../../components/lodder";
import MyfnoLodder from "../../components/fnolodder";
import { useSearchParams, useNavigate } from "react-router-dom";
import { PDFDocument } from "pdf-lib";
import * as pdfjsLib from "pdfjs-dist"; // For handling PDF decryption using pdfjs-dist
import axios from "axios";
import { useSelector } from "react-redux";
import dayjs from 'dayjs'
import formDataaa from "./bullLogoBase64"
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs; 
pdfMake.fonts = {
  Roboto: {
     normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
     bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
     italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
     bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
   },
  }

pdfjsLib.GlobalWorkerOptions.workerSrc = 
  "https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js";



export default function ActiveFnO() {

  
  const [showOtherDocuments, setShowOtherDocuments] = useState(false); // Toggle for other docs
  const [networth, setNetworth] = useState(""); // Net worth input
  const [netErr, setNetErr] = useState(""); // Net worth error state
  const [step, setStep] = useState(1); // Step control (1: Select Proof, 2: Upload File)
  const [uploadMethod, setUploadMethod] = useState("manual"); // Upload method for bank statement
  const [bankStatmentFileName, setBankStatmentFileName] = useState("");
    const [showlodder, setShowLodder] = useState(false);
    const [showfnolodder,setShowfnolodder]=useState(true)
    const [incorrectErr, setInccorectErr] = useState("");
    const [bankStatementFormData, setBankStatementFormData] = useState("");
    const [password, setPassword] = useState("");
    const [open, setOpen] = useState(false);
    const modalPromiseRef = useRef(null);
    const [bankStatmentData, setBankStatmentData] = useState("");
    const [passwordEnterErr, setPassEnterErr] = useState("");
    const [validated, setValidated] = useState(false);
    const [fnostatus,setFnoStatus]=useState(null)
    const [remark,setRemark]=useState("")
    const [hasfno,setHasfno]=useState()
    const [aadharnumber,setAadharnumber]=useState("")

     const [onemoneysuccess,setOneMoneySuccess]=useState(false)
  const [usernetAssets,setUserNetAssets]=useState()
  const [selectedOption, setSelectedOption] = useState("Bank_Statement"); // Selected proof
  const [holdingDataFromRes, setHoldingData] = useState();

  const [display,setDisplay]=useState(false)

  console.log("holdingDataFromRes",holdingDataFromRes)

    const apiTokenFromSelector = useSelector(state => state.auth.apiToken);

      const { selectedYear, setSelectedYear } = useAppData(); // srini - 30-01-25

  
    
  const { userInfo, setUserInfo } = useAppData();
  const { userBanks, setuserBanks } = useAppData();
  // const { userInfo,userBanks } = useAppData(null);

  console.log(userInfo, "USERINFO");

  console.log(userBanks)

  if(userBanks){
  console.log(userBanks[0]?.IFSC_Code,"USERBANK")
  }





  useEffect(() => {

    // setShowLodder(true)
    const clientId = userInfo.CLIENT_ID || localStorage.getItem("userid")
    const payload = {
      ClientCode: clientId
    }
    const authdata = localStorage.getItem("persist:root");

    const parseData = JSON.parse(authdata);
    const userData = JSON.parse(parseData.auth);
    const apiToken = userData?.apiToken; // Use optional chaining to avoid errors

    const apiClient = new ApiClient(apiToken);

    apiClient
      .fetchData(AppConfig.api.Client.info, "POST", payload)
      .then((reqdata) => {
        console.log("API Responseeeee:", reqdata["Success Description"]

        );
        // Ensure Success Description exists and is an array
        const successDescription = reqdata["Success Description"];
        console.log("Type of Success Description:", typeof successDescription);
        console.log("Is Array:", Array.isArray(successDescription));
  
        if (Array.isArray(successDescription)) {
          const hasFNO = successDescription.some(
            (item) => item.COMPANY_CODE === "NSE_FNO" || item.COMPANY_CODE === "BSE_FNO"
          );
          console.log("Computed hasFNO value:", hasFNO);
  
          if (hasFNO) {
           setHasfno(true)
            setFnoStatus("already_active");
            setShowfnolodder(false)
          }else{
            console.log("not active else block")
          setHasfno(false)
          }
        }

        setShowLodder(false)
      })
      .catch((error) => {
        console.error("API Call Failed:", error);
      });
  }, []);

  // useEffect(() => {
  //   const authdata = localStorage.getItem("persist:root");
  //   const parseData = JSON.parse(authdata);
  //   const userData = JSON.parse(parseData.auth);
  //   const apiToken = userData?.apiToken; // Use optional chaining to avoid errors
  
  //   const formData = JSON.stringify({ client_id: userInfo.CLIENT_ID || localStorage.getItem("userid") });
  
  //   console.log("Form Data:", formData);
  
  //   try {
  //     let encData = CryptoJS.AES.encrypt(formData, "96358214256984120").toString();
  //     const payload = { data: encData };
  
  //     console.log("API Payload:", payload);
  
  //     const apiClient = new ApiClient(apiToken);
  
  //     apiClient
  //       .fetchData(AppConfig.api.AadharInfo.aadharInfo, "POST", payload)
  //       .then((reqdata) => {
  //         console.log("RequestInfo API Response:", reqdata);

  //         const decryptResponse = (encryptedData) => {
  //           const secretKey = "96358214256984120"; // Same key used for encryption
  //           const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  //           const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  //           return decryptedData ? JSON.parse(decryptedData) : null; // Parse JSON if valid
  //         };

        
  //         const decryptedResponse = decryptResponse(reqdata);
          
  //         console.log("Decrypted Data:", decryptedResponse);

  //         setAadharnumber(decryptedResponse.aadharno)

  //       })
  //       .catch((error) => {
  //         console.error("API Error:", error);
  //       });
  //   } catch (error) {
  //     console.error("Encryption Error:", error);
  //   }
  // }, []);


  const [searchParams] = useSearchParams();
  // const navigate = useNavigate();


  
  useEffect(() => {
    console.log("USEeFFECT")
    const makeApiCall = async () => {
      const baseUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, baseUrl);
      const success = searchParams.get("success");

      console.log(success)
  
      if (success === "true") {
        // raiseRequest();
       setShowLodder(false);
       setBankStatmentFileName("");
       setInccorectErr("");
       setFnoStatus("pending");
       setOneMoneySuccess(true)
       return;
      }
  
      if (success === "false") {
        console.log("API Call Triggered: Rejection Flow");
  
        // Get `client_id`
        const client_id = userInfo.CLIENT_ID || localStorage.getItem("userid");

          // 🔹 Retrieve `source_id` from localStorage
      const storedSourceId = localStorage.getItem("source_id") || "UNKNOWN_SOURCE";
      console.log("Retrieved Source ID:", storedSourceId);
  
       
  
        // Get formatted date
        const getFormattedDate = () => {
          const now = new Date();
          const day = String(now.getDate()).padStart(2, "0");
          const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-based
          const year = now.getFullYear();
          const hours = String(now.getHours()).padStart(2, "0");
          const minutes = String(now.getMinutes()).padStart(2, "0");
  
          return `${year}-${month}-${day}`;
          // 2025-03-03
        };
  
        const approvedon = getFormattedDate();
        console.log("Formatted Date:", approvedon);
  
        // Prepare form data
        const formData = {
          client_id,
          status: "reject",
          approvedon,
          approvedby: "admin",
          remark: "one money failed",
          image_name: "Not available",
          bucketname: "oneMoney",
          src_id: storedSourceId,
        };
  
        console.log("Form Data:", formData);
  
        try {
          // Encrypt data
          const secretKey = "96358214256984120";
          const encryptedRequestBody = CryptoJS.AES.encrypt(
            JSON.stringify(formData),
            secretKey
          ).toString();
  
          console.log("Encrypted Data:", encryptedRequestBody);
  
          const payload = { data: encryptedRequestBody };
  

          const authdata = localStorage.getItem("persist:root");
          const parseData = JSON.parse(authdata);
          const userData = JSON.parse(parseData.auth);
          const apiToken = userData?.apiToken;

          const apiClient = new ApiClient(apiToken);
  
          const response =apiClient
            .fetchData(
              AppConfig.api.RejectRequest.rejectRequest,
              "POST",
              payload
            )
  
          console.log("API Response:", response);
  
          if (response.status === 200) {
            // Decrypt response
            const bytes = CryptoJS.AES.decrypt(response.data, secretKey);
            const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
            const parsedData = decryptedData ? JSON.parse(decryptedData) : null;
  
            console.log("Decrypted Response:", parsedData);

            // Show error message
            Swal.fire({
              title: "Sorry ...!",
              html: `<i class="fas fa-info-circle custom-icon"></i> 
                 <p>Unfortunately, one money failed. Please try other options.</p>`,
              confirmButtonText: "Ok",
              confirmButtonColor: "#f3d45e",
              background: "#f8f9fa",
              color: "#333",
              customClass: {
                confirmButton: BSstyles.customConfirmButton,
              },
            });
  
          setFnoStatus("Rejected")
          
          }
        } catch (error) {
          console.error("Error in API call:", error);
        }
  
     
  
      
      }
    };
  
    makeApiCall();
  }, [userInfo, searchParams]); // 🔹 Add dependencies
  
  

  // const raiseRequest = () => {

 
  //   const authdata = localStorage.getItem("persist:root");
  //   const parseData = JSON.parse(authdata);
  //   const userData = JSON.parse(parseData.auth);
  //   const apiToken = userData?.apiToken; // Use optional chaining to avoid errors
  //   const client_id = userInfo.CLIENT_ID || localStorage.getItem("userid");
  //   const formData = { client_id };
  //   console.log("FORMDATA",formData);

  //   const formDataString = JSON.stringify(formData);
  //   let encData = CryptoJS.AES.encrypt(formDataString, "96358214256984120").toString();

  //   const payload = { data: encData };
  //   console.log("MINE",payload);

  //   const apiClient = new ApiClient(apiToken);


  //   apiClient
  //     .fetchData(AppConfig.api.CreateFnoRequest.createRequest, "POST", payload)
  //     .then((createreqdata) => {
  //       if (createreqdata.status === 200) {
  //         setShowLodder(false);
  //         setBankStatmentFileName("");
  //         setInccorectErr("");

  //         const decryptResponse = (encryptedData) => {
  //           const secretKey = "96358214256984120";
  //           const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  //           const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  //           return decryptedData ? JSON.parse(decryptedData) : null;
  //         };

  //         const encryptedResponse = createreqdata.data.data;
  //         const decryptedResponse = decryptResponse(encryptedResponse);
  //         console.log("Decrypted Data:", decryptedResponse);

  //         setFnoStatus("pending");
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("An Error Occurred", error);
  //       setShowLodder(false);
  //       setInccorectErr("Something went wrong. Please try again.");
  //     });
  // };

  const fetchAadharNumber = async () => {
    
    try {
      const authdata = localStorage.getItem("persist:root");
      const parseData = JSON.parse(authdata);
      const userData = JSON.parse(parseData.auth);
      const apiToken = userData?.apiToken;
  
      const formData = JSON.stringify({ client_id: userInfo.CLIENT_ID || localStorage.getItem("userid")});

      console.log(formData)

      console.log("formData from fetchAadharNumber",formData)
      let encData = CryptoJS.AES.encrypt(formData, "96358214256984120").toString();
      const payload = { data: encData };
  
      const apiClient = new ApiClient(apiToken);
      const reqdata = await apiClient.fetchData(AppConfig.api.AadharInfo.aadharInfo, "POST", payload);
  
      const secretKey = "96358214256984120";
      const bytes = CryptoJS.AES.decrypt(reqdata, secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      const parsedData = decryptedData ? JSON.parse(decryptedData) : null;

      console.log(parsedData?.aadharno)
  
      return parsedData?.aadharno || null;
    } catch (error) {
      console.error("Error fetching Aadhar:", error);
      return null;
    }
  };

  // console.log("AADHAR",aadharnumber)
  

  // Proceed to File Upload Step (Validate Net Worth)
  const handleProceed = () => {
    if (!networth) {
      setNetErr("Net worth is required!");
      return;
    }else if(networth<=0){
      setNetErr("Net worth is Invalid!");
      return;
    }

    const client_id= userInfo.CLIENT_ID || localStorage.getItem("userid");
    const authdata = localStorage.getItem("persist:root");
    const parseData = JSON.parse(authdata);
    const userData = JSON.parse(parseData.auth);
    const apiToken = userData.apiToken;

    console.log(apiToken)


  

  //   const formData = {
  //     client_id,
  //     networth: networth.replaceAll(",", "")
  //   };
    

  // console.log(formData);

  //   const formDataString = JSON.stringify(formData);

  //   let encrequestBody = CryptoJS.AES.encrypt(
  //     formDataString,
  //     "96358214256984120"
  //   ).toString();

  //   console.log(encrequestBody);

    const payload={
      data:{
        email: userInfo?.CLIENT_ID_MAIL,
        mobile: userInfo?.MOBILE_NO,
        net_worth:networth.replaceAll(",", "")
      }
    }

    console.log("NetWorth payload",payload);

    setShowLodder(true)

    const apiClient = new ApiClient(apiToken);
  
          apiClient
            .fetchData(
              AppConfig.api.UpdateFnO.updateFnO,
              "POST",
              payload
            )
            .then((netWorthResData) => {
              console.log(netWorthResData)
             
              // localStorage.setItem("networth",networth);

              // const decryptResponse = (encryptedData) => {
              //   const secretKey = "96358214256984120"; // Same key used for encryption

              //   // Decrypt the data
              //   const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);

              //   // Convert bytes to string (UTF-8)
              //   const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

              //   return decryptedData ? JSON.parse(decryptedData) : null; // Parse JSON if valid
              // };

              // // Example usage
              // const encryptedResponse = netWorthResData

              // const decryptedResponse = decryptResponse(encryptedResponse);
              // console.log("Decrypted Data:", decryptedResponse);
              if (netWorthResData?.data?.message =="Net worth updated successfully"){
                console.log("inside")
                setShowLodder(false)
                // setShowLodder(false);
              }
            })
            .catch((error) => {
              console.log("An Error Occurred", error);
              // setShowLodder(false);
              // setInccorectErr("Something went wrong. Please try again.");
            });

    setNetErr(""); // Clear error if valid
    setStep(2); // Move to the next step (Upload File)
  };


  useEffect(() => {


    console.log("UU1 inside UU")

    console.log("UU2",userInfo)

     console.log("UU3",hasfno)

     console.log(hasfno == false)

    if(hasfno == false){



    console.log("UU4 not active")
    console.log("UU5",userInfo?.CLIENT_ID)
    // if (!userInfo || !userInfo.CLIENT_ID) return; 
    // // Prevent running if userInfo is not available

    setShowfnolodder(true);
    // setIsLoading(true)

    const authdata = localStorage.getItem("persist:root");
    console.log("UU6",authdata)
    if (!authdata) {
      console.log("Auth data not found in localStorage");
      setShowfnolodder(false);
      return;
    }

    try {
      const parseData = JSON.parse(authdata);
      const userData = JSON.parse(parseData.auth);
      const apiToken = userData?.apiToken; // Use optional chaining to avoid errors

      console.log("UU7",apiToken)

      if (!apiToken) {
        console.log("API token not found");
        setShowfnolodder(false);
        return;
      }
      const apiClient = new ApiClient(apiToken);
      // const formData = JSON.stringify({ client_id: userInfo.CLIENT_ID || localStorage.getItem("userid")});

      // console.log(formData)

      // let encData = CryptoJS.AES.encrypt(formData, "96358214256984120").toString();

      const formData = { "data": { "fdate": "", "tdate": "" } }

      apiClient
        .fetchData(AppConfig.api.fno.requestList, "POST", formData)
        .then((response) => {
          console.log("API Response:", response);
          const data = response?.data
          console.log("dataaa",data)
          const filtered = data.filter(ele => ele.client_id === userInfo.CLIENT_ID);

          const hasApproved = filtered.some(ele => ele.status === "Approved");
          const hasPending = filtered.some(ele => ele.status === "Pending");

          // Count rejected ones
          const rejectedCount = filtered.filter(ele => ele.status === "Rejected").length;

          console.log("Approved:", hasApproved, "Pending:", hasPending, "Rejected:", rejectedCount);
          if (hasApproved || hasPending || rejectedCount < 3){
            const payload = {
              data: {
                client_id: userInfo.CLIENT_ID || localStorage.getItem("userid")
              }
            };
            console.log("API Payload:", payload);
            apiClient
              .fetchData(AppConfig.api.fno.requestStatus, "POST", payload)
              .then((reqdataRes) => {
                console.log("API Response:", reqdataRes);

                if (reqdataRes.status === 200) {
                  setShowfnolodder(false);
                  // setValidated(true);
                  setBankStatmentFileName("");
                  setInccorectErr("");


                  if (reqdataRes.reqStatus === "Initialized") {
                    setFnoStatus("Initialized");
                  }
                  else if (reqdataRes.reqStatus === "Pending") {
                    setFnoStatus("pending");
                  }
                  else if (reqdataRes.reqStatus === "Approved") {
                    setFnoStatus("success");
                  }
                  else if (reqdataRes.reqStatus === "Rejected") {
                    setFnoStatus("rejected");
                    // function customDecode(str) {
                    //   return decodeURIComponent(str);
                    // }
                    // const decodedRemark = customDecode(decryptedResponse?.[0]?.remark || "");
                    setRemark(reqdataRes.remark)
                  } else {
                    setFnoStatus(null)
                  }
                }
              })
              .catch((error) => {
                console.error("API Call Failed:", error);
                setShowfnolodder(false);
                setInccorectErr("Something went wrong. Please try again.");
              });
          }else{
            setDisplay(true)
            setFnoStatus("rejected")
            setShowfnolodder(false);
          }
          // if (reqdataRes.status === 200) {
          //   setShowfnolodder(false);
          //   // setValidated(true);
          //   setBankStatmentFileName("");
          //   setInccorectErr("");


          //   if (reqdataRes.reqStatus === "Initialized") {
          //     setFnoStatus("Initialized");
          //   }
          //   else if (reqdataRes.reqStatus === "Pending") {
          //     setFnoStatus("pending");
          //   }
          //   else if (reqdataRes.reqStatus === "Approved") {
          //     setFnoStatus("success");
          //   }
          //   else if (reqdataRes.reqStatus === "Rejected") {
          //     setFnoStatus("rejected");
          //     // function customDecode(str) {
          //     //   return decodeURIComponent(str);
          //     // }
          //     // const decodedRemark = customDecode(decryptedResponse?.[0]?.remark || "");
          //     setRemark(reqdataRes.remark)
          //   } else {
          //     setFnoStatus(null)
          //   }
          // }
        })
        .catch((error) => {
          console.error("API Call Failed:", error);
        });

    } catch (error) {
      console.error("Error processing auth data:", error);
      setShowfnolodder(false);
    }
    }
  }, [userInfo,hasfno]); // 👈 Add userInfo as a dependency


    // Custom Radio Button Styling
    const CustomRadio = styled(Radio)(({ theme }) => ({
      "& .MuiButtonBase-root": {
        padding: "8px", // Adjust padding for spacing
      },
  
      "& .MuiSvgIcon-root": {
        width: 28, // Outer circle size
        height: 28,
        borderRadius: "50%",
        border: "1px solid #fff", // Black border for outer circle
        backgroundColor: "#0b1420", // Default background
      },
  
      "& .MuiSvgIcon-root path": {
        display: "none", // Hides the default inner dot
      },
  
      "&.Mui-checked .MuiSvgIcon-root": {
        color: "#F3D45E", // Yellow fill for checked state
        borderRadius: "50%",
        border: "1px solid #fff", // Keeps outer black border when checked
        width: 28,
        height: 28,
        transition: "all 0.3s ease", // Smooth transition
      },
  
      "&.Mui-checked .MuiSvgIcon-root path": {
        display: "block", // Ensure the inner dot is visible when checked
        fill: "#F3D45E", // Make the inner dot yellow
      },
  
      // Media queries for responsiveness
      "@media (max-width: 780px)": {
        "& .MuiSvgIcon-root": {
          width: 24,
          height: 24,
        },
        "&.Mui-checked .MuiSvgIcon-root": {
          width: 24,
          height: 24,
        },
      },
  
      "@media (max-width: 600px)": {
        "& .MuiSvgIcon-root": {
          width: 20,
          height: 20,
        },
        "&.Mui-checked .MuiSvgIcon-root": {
          width: 20,
          height: 20,
        },
      },
  
      "@media (max-width: 500px)": {
        "& .MuiSvgIcon-root": {
          width: 18,
          height: 18,
        },
        "&.Mui-checked .MuiSvgIcon-root": {
          width: 18,
          height: 18,
        },
      },
  
      "@media (max-width: 400px)": {
        "& .MuiSvgIcon-root": {
          width: 18,
          height: 18,
        },
        "&.Mui-checked .MuiSvgIcon-root": {
          width: 18,
          height: 18,
        },
      },
  
      "@media (max-width: 320px)": {
        "& .MuiSvgIcon-root": {
          width: 16,
          height: 16,
        },
        "&.Mui-checked .MuiSvgIcon-root": {
          width: 16,
          height: 16,
        },
      },
    }));

  // Handle checkbox selection (only one at a time)
  const handleCheckboxChange = (option) => {
    setSelectedOption(option);
  };

  const HandleReset = () => {
    // Handle reset logic here if necessary
    setBankStatmentFileName("");
    setPassEnterErr("");
    setPassword("");
    setBankStatementFormData("");
  };


  const ConvertBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };


  const handlePasswordSubmit = (enteredPassword) => {
    console.log(enteredPassword);
    if (enteredPassword === "") {
      // setError({ errType: 2, errMsg: "Please Enter the Password" });
      console.log("Please Enter the Password");
      setPassEnterErr("Please Enter the Password");
    } else {
      setPassword(enteredPassword);
      setPassEnterErr("");

      // onClose(); // Closing the modal
      setOpen(false);

      if (modalPromiseRef.current && modalPromiseRef.current.resolve) {
        modalPromiseRef.current.resolve(enteredPassword);
      }
    }
  };

  const handleCancel = () => {
    // if (modalPromiseRef) {
    //   modalPromiseRef.reject();
    // }
    setOpen(false);
    setBankStatmentFileName("");
    setPassEnterErr("");
    setPassword("");
    setBankStatementFormData("");
  };




  const HandleFile = async (file) => {
    setBankStatmentFileName("");
    setBankStatementFormData("");
    setPassword("");
    setValidated(false);
    let fsize = (file.size / (1024 * 1024)).toFixed(2);
    console.log(file.type, "file type");
  
    if (file.type !== "application/pdf") {
      setInccorectErr("Invalid File Format for Bank Statement (Only PDF supported)");
      console.log("Invalid File Format for Bank Statement (Only PDF supported)");
      return;
    } else if (fsize > 20) {
      setInccorectErr("Max 20MB allowed");
      console.log("Max 20MB allowed");
      return;
    } else {
      const processFirstPage = async (pdfDoc) => {
        try {
          const firstPage = await pdfDoc.getPage(1);
          const firstPageCanvas = document.createElement("canvas");
          const context = firstPageCanvas.getContext("2d");
          const viewport = firstPage.getViewport({ scale: 1 });
  
          firstPageCanvas.height = viewport.height;
          firstPageCanvas.width = viewport.width;
  
          await firstPage.render({ canvasContext: context, viewport }).promise;
  
          const base64PdfImage = firstPageCanvas.toDataURL();
          setInccorectErr("");

          if(selectedOption=="Bank_Statement"){
            setBankStatementFormData(base64PdfImage);
          }
          
          // ✅ Automatically trigger validation after file processing
          // handleValidate();
        } catch (error) {
          console.error("❌ Error extracting first page:", error);
          setInccorectErr("Failed to extract the first page of the PDF");
          setOpen(false);
          HandleReset();
        }
      };
  
      const bs = async () => {
        const fileReader = new FileReader();
        fileReader.onload = async () => {
          console.log("Function running in AA");
          const pdfBytes = new Uint8Array(fileReader.result);
          let pdfDoc;
          let isPasswordRequired = false;
  
          try {
            const loadingTask = pdfjsLib.getDocument({ data: pdfBytes });
            pdfDoc = await loadingTask.promise;
  
            // ✅ Process first page & validate immediately
            await processFirstPage(pdfDoc);
            return;
          } catch (error) {
            console.error("Error processing PDF:", error);
            if (error.message === "No password given") {
              console.log("🔑 PDF is password protected.");
              isPasswordRequired = true;
            } else {
              setOpen(false);
              setInccorectErr("Incorrect password or the PDF file is inaccessible. Please check your password and ensure the file is not corrupted or restricted");
              HandleReset();
              return;
            }
          }
  
          if (isPasswordRequired) {
            setOpen(true);
            setPassword("");
            setInccorectErr("");
  
            try {
              const promise = new Promise((resolve, reject) => {
                modalPromiseRef.current = { resolve, reject };
              });
  
              const enteredPassword = await promise;
              console.log("🔓 Password entered:", enteredPassword);
  
              const decryptedLoadingTask = pdfjsLib.getDocument({
                data: pdfBytes,
                password: enteredPassword,
              });
  
              pdfDoc = await decryptedLoadingTask.promise;
              console.log("PDF decrypted successfully.");
              setOpen(false);
  
              await processFirstPage(pdfDoc);
            } catch (decryptError) {
              console.error("Unable to decrypt PDF with provided password:", decryptError);
              setOpen(false);
              setInccorectErr("Incorrect password or the PDF file is inaccessible.");
              HandleReset();
            }
          }
        };
        fileReader.readAsArrayBuffer(file);
      };
  
      await bs();
      const base64 = await ConvertBase64(file);
      console.log(base64);
      setBankStatmentFileName(file.name);
      setBankStatmentData(base64);
    }
  };


  

  const handleProceedOneMoney = async () => {
    const aadharNumber = await fetchAadharNumber();
    // const aadharNumber = "0319";
  
    if (!aadharNumber) {
      console.error("Aadhar number not available");
      return;
    }
  
    let emailid = userInfo.CLIENT_ID_MAIL;
    let mobileno = userInfo.MOBILE_NO;
    let ifsc = userBanks?.[0]?.IFSC_Code || ""; // Handle potential undefined error
  
    const authdata = localStorage.getItem("persist:root");
    const parseData = JSON.parse(authdata);
    const userData = JSON.parse(parseData.auth);
    const apiToken = userData.apiToken;
  
    const client_id = userInfo.CLIENT_ID || localStorage.getItem("userid");
    const apiClient = new ApiClient(apiToken);
    const fno_type="one_money"
    const formData = { client_id ,fno_type};
  
    console.log("FORMDATA", formData);
  
    const formDataString = JSON.stringify(formData);
    let encData = CryptoJS.AES.encrypt(formDataString, "96358214256984120").toString();
  
    const payload = { data: encData };
    console.log("Encrypted Payload:", payload);
  
    setShowLodder(true);
  
    try {
      const createreqdata = await apiClient.fetchData(AppConfig.api.fno.createRequest, "POST", payload);
  
      if (createreqdata.status === 200) {
        const decryptResponse = (encryptedData) => {
          const secretKey = "96358214256984120";
          const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
          const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
          return decryptedData ? JSON.parse(decryptedData) : null;
        };
  
        const encryptedResponse = createreqdata.data.data;
        const decryptedResponse = decryptResponse(encryptedResponse);
        console.log("Decrypted Data:", decryptedResponse);

  
        if (decryptedResponse?.msg === "Request addded successfully") {
          const src_id = decryptedResponse.src_id; // Extract src_id from response

          localStorage.setItem("source_id", src_id); 
          console.log("Source ID stored:", src_id);
  
          let oneMoneyPayload = {
            emailid: emailid,
            mobileno: mobileno,
            aadhar: aadharNumber.substring(8, 12),
            ifsc: ifsc,
            type: "3",
            incommingSource: "back_office",
            src_id: src_id, // Pass src_id here
          };
  
          console.log("Payload for OneMoney:", oneMoneyPayload);
  
          try {
            const oneMoneyResponse = await apiClient.fetchData(AppConfig.api.OneMoney.oneMoney, "POST", oneMoneyPayload);
  
            if (oneMoneyResponse.status === 200) {
              setShowLodder(false);
              window.open(oneMoneyResponse.url, "_self");
  
              // Reset form states
              setBankStatmentFileName("");
              setInccorectErr("");
            }
          } catch (error) {
            console.log("An Error Occurred while calling OneMoney API:", error);
            setShowLodder(false);
            setInccorectErr("Something went wrong. Please try again.");
          }
        }
      }
    } catch (error) {
      console.log("An Error Occurred during CreateFnoRequest API:", error);
      setShowLodder(false);
      setInccorectErr("Something went wrong. Please try again.");
    }
  };
  


  useEffect(() => {
    if (bankStatementFormData) {
      handleValidate();
    }
  }, [bankStatementFormData]); 

  const handleValidate=()=>{

    setShowLodder(true)



    const authdata = localStorage.getItem("persist:root");
    const parseData = JSON.parse(authdata);
    const userData = JSON.parse(parseData.auth);
    const apiToken = userData.apiToken;

    let emailid = userInfo.CLIENT_ID_MAIL;
    let mobileno = userInfo.MOBILE_NO;

    // const dataURI = "data:image/png;base64,iVBORw0KGgoAAAANSUh..........";
    const base64String = bankStatementFormData.split(",")[1];
    console.log(base64String);

    const payload = {
      data: {
        email: emailid,
        mobile: mobileno,
        type: "bank_statment",
        filetype: "png",
        base64: base64String,
        //  bankstmtpwd:password
      }
    }

      console.log(payload)

    const apiClient = new ApiClient(apiToken);
      apiClient
        .fetchData(AppConfig.api.fno.ocrCheck, "POST", payload)
        // .fetchData(`http://localhost:5000/api/document/validate`, "POST", payload)
        .then((commfileup) => {
          console.log("commfileup",commfileup)
          if(commfileup.status===200){
            // const data = commfileup.data.data
            if(commfileup.response.success === true){   
                // this.setState({islodding:false, allowValidate: false, allowContinue:true })
                setValidated(true)
                setShowLodder(false)
                console.log("validated successfully")
              
            }else{
                HandleReset()
                setValidated(false)
                setShowLodder(false)
                setInccorectErr(commfileup.response.message)
                // this.setState({islodding:false, errtype:1, errmsg:data.bankstatement.message, allowValidate: false})
            }
        }else{
          setShowLodder(false)
          setInccorectErr("Something went wrong please try again")

                // this.setState({islodding:false, errtype:1, errmsg:'Something went wrong please try again'})
            }
        })
        .catch((error) => {
          console.log("An Error Occurred", error);
          setShowLodder(false);
          setInccorectErr("Something went wrong. Please try again.");
        });

  }

    console.log("CUR",bankStatementFormData)
    console.log("CURPass",password)

    const handleUpload = async () => {
    console.log("bppp", bankStatementFormData);

  
    const authdata = localStorage.getItem("persist:root");
    const parseData = JSON.parse(authdata);
    const userData = JSON.parse(parseData.auth);
    const apiToken = userData.apiToken;


    
  
    const client_id = userInfo.CLIENT_ID || localStorage.getItem("userid");
    console.log("client_id from handleUpload", client_id);
  
    if (bankStatmentFileName === "") {
      setInccorectErr("Please select the file");
      setShowLodder(false);
      return;
    }
  
    let emailid = userInfo.CLIENT_ID_MAIL;
    let mobileno = userInfo.MOBILE_NO;
  
    console.log("VARUNTEJA", AppConfig.api);
  
    const apiClient = new ApiClient(apiToken);
    // const formData = { client_id };
    // console.log(formData);
  
    // const formDataString = JSON.stringify(formData);
  
    // let encData = CryptoJS.AES.encrypt(formDataString, "96358214256984120").toString();
  
    const payload = { data: {
      client_id, file_name: `${selectedOption}_${mobileno}.pdf`, emailid, src:"back_office",password
    } };
    console.log(payload);

    setShowLodder(true);

  
    try {
      const createreqdata = await apiClient.fetchData(
        AppConfig.api.fno.createRequest,
        "POST",
        payload
      );

      console.log("createreqdata",createreqdata)
  
      if (createreqdata.msg === 'FNO request created successfully') {
        // setShowLodder(false);
        
          console.log("api call to confirm")

          // const timestamp = new Date()
          //   .toISOString()
          //   .replace('T', '_')  // Replace 'T' with '_'
          //   .replace(/:/g, '-') // Replace ':' with '-'
          //   .split('.')[0]; // Remove milliseconds and 'Z'

          // console.log(timestamp); 



            const payload = { data:{
              "email":emailid,
              "mobile":mobileno,
              "document_type":`${selectedOption}`,
                "base64":bankStatmentData,
              "password":password,
              "src":"back_office",
              // aadharno: aadharNumber.substring(8, 12),
              // bankStatmentData,
              // fno_source_image: bankStatmentFileName,
              // incommingSource: "back_office",
              // fno_type: selectedOption, 
              // src_id: decryptedResponse.src_id,
              // fno_doc_password:password
            }
            };
            

          console.log(payload)
  
          try {
            const commfileup = await apiClient.fetchData(
              AppConfig.api.fno.confirmDocs,
              "POST",
              payload
            );
  
            console.log("commfileup", commfileup, AppConfig);
            setFnoStatus("pending");

            
          setBankStatmentFileName("");
          setInccorectErr("");

            setShowLodder(false)
          } catch (error) {
            console.log("An Error Occurred", error);
            setShowLodder(false);
            setInccorectErr("Something went wrong. Please try again.");
          }
       
      } else if (createreqdata?.reqStatus === 'Limit Exceeded'){
        setShowLodder(false);
        setInccorectErr("You have submitted the F&O request three times, and all have been rejected. Please contact our support team at support@tradeboss.co for further assistance.")
      }

    } catch (error) {
      console.log("An Error Occurred", error);
      setShowLodder(false);
      setInccorectErr("Something went wrong. Please try again.");
    }
  };
  
  

  // Back to selection step
  const handleBack = () => {
    setStep(1);
    setBankStatmentFileName("");
    setPassEnterErr("");
    setPassword("");
    setBankStatementFormData("");
    setBankStatmentData("")
    setInccorectErr("")
    setValidated(false)
  };

  // Corresponding points for each option
  const optionDetails = {
    Bank_Statement: [
      "Upload last 6 months statement",
      "The statement should be of a verified bank on TradeBoss only",
      "At least one transaction of value > ₹10,000",
    ],
    Net_Worth: [
      "Should be of latest month only",
      "Should display the value of securities lying in demat account (it should be more than ₹10,000)",
    ],
    Demat_Statement: [
      "Should be of latest month only",
      "Should display the values of securities lying in demat account (it should be more than ₹10,000)",
    ],
    ITR: [
      "Gross annual income should be more than ₹1,20,000 lacs",
      "ITR Acknowledgement should be of last Financial Year",
    ],
    Salary_Slip: [
      "Should not be more than 2 months old",
      "Gross monthly salary should be more than ₹10,000",
    ],
    Form_16:[
      "Your full name and PAN number must be clearly visible",
      "The Form 16B should be from the latest assessment year"
    ]
  };


  console.log("selecteddddddd",selectedOption)


  const handleUploadGrey=()=>{
      
    if (bankStatmentFileName == "") {
      setInccorectErr("Please select the file");
      setShowLodder(false);
      return;
    }

  }

  const handleReupload=()=>{
    console.log("FNOOOO")
    setFnoStatus("")
  }

   const fetchAssets = async () => {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      const apiClient = new ApiClient(apiTokenFromSelector);
      setShowLodder(true)
      apiClient.fetchData(
        AppConfig.api.Client.assets,
        "POST",
        {
          "Client_Code": userInfo.CLIENT_ID || localStorage.getItem("userid"),
          "FinStyr": selectedYear && selectedYear.Database_Year ? selectedYear.Database_Year : new Date().getFullYear()
        })
        .then((response) => {
          console.info(response);
          setShowLodder(false)
          // if(response===401){setShowModal(true)}
          if (response && response.Success === "True" && response.hasOwnProperty("Success Description")) {
            let responseData = response["Success Description"];
            console.info(`data ${responseData}`);
            console.info(`NetAssetsDetails ${JSON.stringify(responseData[0])}`);
            const netAssets = responseData["NetAssetsDetails"];

            let circleData = {
              title: "Net Assets",
              data: []
            };
            Object.entries(netAssets).forEach(([key, value], index) => {
              let color;
              switch (key) {
                case 'NetAssets':
                  color = "#517AAF";
                  break;
                case 'MarketValue':
                  color = "#FF7F09";
                  break;
                case 'Total_Return':
                  color = "#7DAB1C";
                  break;
              };
              circleData.data.push({
                name: key,
                value: value,
                color: color
              });
            });
            // setUserNetAssets(circleData);

            console.log("circleData", circleData.data[1].value)
            setUserNetAssets(circleData.data[1].value)
            if (circleData.data[1].value > 150) {
              setSelectedOption("Holdings_Statement")
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };

  useEffect(() => {
    fetchAssets();
  }, []);

     const handleSubmitHS = async () => {
    const base64 = await handleGeneratePDF();
    console.log("hss 1", base64);
  
  
    const authdata = localStorage.getItem("persist:root");
    const parseData = JSON.parse(authdata);
    const userData = JSON.parse(parseData.auth);
    const apiToken = userData.apiToken;


    
  
    const client_id = userInfo.CLIENT_ID || localStorage.getItem("userid");
    console.log("client_id from handleUpload 2", client_id);
  
   
  
    let emailid = userInfo.CLIENT_ID_MAIL;
    let mobileno = userInfo.MOBILE_NO;
  
    console.log("VARUNTEJA 3", AppConfig.api);
  
    const apiClient = new ApiClient(apiToken);
    // const formData = { client_id };
    // console.log(formData);
  
    // const formDataString = JSON.stringify(formData);
  
    // let encData = CryptoJS.AES.encrypt(formDataString, "96358214256984120").toString();
  
    const payload = { data: {
      client_id,file_name:`${selectedOption}_${mobileno}.pdf`,emailid
    } };
    console.log(payload);

    setShowLodder(true);

  
    try {
      const createreqdata = await apiClient.fetchData(
        AppConfig.api.fno.createRequest,
        "POST",
        payload
      );
     console.log("createreqdata 4",createreqdata)
         if (createreqdata.msg === 'FNO request created successfully') {
        // setShowLodder(false);
         console.log("api call to confirm 5")
  
        // const decryptResponse = (encryptedData) => {
        //   const secretKey = "96358214256984120"; // Same key used for encryption
        //   const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        //   const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        //   return decryptedData ? JSON.parse(decryptedData) : null;
        // };
  
        // const encryptedResponse = createreqdata.data.data;
        // const decryptedResponse = decryptResponse(encryptedResponse);
  
        // console.log("Decrypted Data:", decryptedResponse);



     

           const payload = {
             data: {
               "email": emailid,
               "mobile": mobileno,
               "document_type": `${selectedOption}`,
               "base64": `data:application/pdf;base64,${base64}`,
               "password": password

               // aadharno: aadharNumber.substring(8, 12),
               // bankStatmentData,
               // fno_source_image: bankStatmentFileName,
               // incommingSource: "back_office",
               // fno_type: selectedOption, 
               // src_id: decryptedResponse.src_id,
               // fno_doc_password:password
             }
           };
            

          console.log(payload)
            

          console.log(payload)
  
          try {
            const commfileup = await apiClient.fetchData(
              AppConfig.api.fno.confirmDocs,
              "POST",
              payload
            );
  
            console.log("commfileup 6", commfileup, AppConfig);
            setFnoStatus("pending");

            
          setBankStatmentFileName("");
          setInccorectErr("");

            setShowLodder(false)
          } catch (error) {
            console.log("An Error Occurred", error);
            setShowLodder(false);
            setInccorectErr("Something went wrong in upload api Please try again.");
          }
        
      }
    } catch (error) {
      console.log("An Error Occurred", error);
      setShowLodder(false);
      setInccorectErr("Something went wrong in create request Please try again.");
    }
  };

    const handleGeneratePDF = async () => {



    let holdingsData = holdingDataFromRes
    let clientInfo = userInfo

    const companyInfo = [
      {
        columns: [
          {
            image: formDataaa.base64,
            width: 50,
          },
          {
            stack: [
              { text: 'Triveni Management Consultancy Services Ltd.', bold: true, fontSize: 12 },
              { text: 'A-2, Bandra Liberty, 98-B, Hill Road, Bandra West, Mumbai 400050', fontSize: 9 },
              { text: 'CIN: U67120MH1995PLC085717   SEBI Reg No: INZ000219738   DP ID: 12101800', fontSize: 9 }
            ],
            margin: [20, 0, 0, 0]
          }
        ],
        margin: [0, 0, 0, 30]
      },
      {
        text: 'Client Holdings Statement',
        style: 'header',
        alignment: 'center',
        margin: [0, 0, 0, 10]
      }
    ];

    // === Client Info Table ===
    const clientInfoTable = {
      style: "clientInfoTable", // style reference here
      table: {
        widths: ["35%", "65%"],
        body: [
          [{ text: 'BO Id', bold: true }, clientInfo.CLIENT_DP_CODE || 'N/A'],
          [{ text: 'Client Name', bold: true }, clientInfo.CLIENT_NAME || 'N/A'],
          [{ text: 'Client Code', bold: true }, clientInfo.CLIENT_ID || 'N/A'],
          [{ text: 'Email', bold: true }, clientInfo.CLIENT_ID_MAIL || 'N/A'],
          [{ text: 'Mobile No', bold: true }, clientInfo.MOBILE_NO || 'N/A'],
          [
            { text: 'Address', bold: true },
            `${clientInfo.CL_RESI_ADD1}, ${clientInfo.CL_RESI_ADD2}, ${clientInfo.CL_RESI_ADD3}` || 'N/A'
          ]
        ]
      },
      layout: {
        hLineWidth: () => 0.5,
        vLineWidth: () => 0.5,
        hLineColor: () => '#aaa',
        vLineColor: () => '#aaa',
        paddingLeft: () => 5,
        paddingRight: () => 5,
        paddingTop: () => 3,
        paddingBottom: () => 3
      },
      margin: [0, 0, 0, 20]
    };

    // === Holdings Table ===
    const holdingsTableBody = [
      [
        { text: "SL.No", style: "tableHeader" },
        { text: "Symbol", style: "tableHeader" },
        { text: "Quantity", style: "tableHeader" },
        { text: "Avg Cost", style: "tableHeader" },
        { text: "Buy Value", style: "tableHeader" },
        { text: "LTP", style: "tableHeader" },
        { text: "Cur. Val", style: "tableHeader" },
        { text: "P&L", style: "tableHeader" },
        { text: "% Holding", style: "tableHeader" }
      ]
    ];

    holdingsData.forEach((item, index) => {
      const qty = Number(item.NET).toFixed(0);
      const avgCost = Number(item.PURCHASE_PRICE).toFixed(2);
      const buyVal = (qty * avgCost).toFixed(2);
      const ltp = Number(item.SCRIP_VALUE).toFixed(2);
      const curVal = Number(item.AMOUNT).toFixed(2);
      const pnl = (curVal - buyVal).toFixed(2);
      const pnlText = {
        text: (pnl >= 0 ? "+" : "") + pnl,
        color: pnl >= 0 ? "green" : "red",
        style: "tableCell"
      };
      const percentHold = Number(item.PERCENT_HOLD || 0).toFixed(2) + "%";

      holdingsTableBody.push([
        { text: index + 1, style: "tableCell" },
        { text: item.SCRIP_SYMBOL, style: "tableCell" },
        { text: qty, style: "tableCell" },
        { text: avgCost, style: "tableCell" },
        { text: buyVal, style: "tableCell" },
        { text: ltp, style: "tableCell" },
        { text: curVal, style: "tableCell" },
        pnlText,
        { text: percentHold, style: "tableCell" }
      ]);
    });

    const docDefinition = {
      content: [
        ...companyInfo,
        clientInfoTable,
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "*", "*", "*", "*", "*", "*", "*"],
            body: holdingsTableBody
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: () => "#000",
            vLineColor: () => "#000"
          }
        }
      ],
      styles: {
        header: {
          fontSize: 12,
          bold: true,
          marginBottom: 10,
          font: "Roboto"
        },
        tableHeader: {
          fontSize: 8,
          bold: true,
          fillColor: '#f0f0f0',
          alignment: 'center'
        },
        tableCell: {
          fontSize: 8,
          alignment: 'center'
        },
        clientInfoTable: {
          fontSize: 9 // or 7 if you want it even smaller
        }
      }
    };

    return new Promise((resolve) => {
      pdfMake.createPdf(docDefinition).getBase64((base64) => {
        resolve(base64);

      });
    });
  };


  const fetchData = async () => {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      setShowLodder(true)
      const apiClient = new ApiClient(apiTokenFromSelector);
      apiClient.fetchData(
        AppConfig.api.Client.holdings,
        "POST",
        {
          "CLIENT_ID": userInfo.CLIENT_ID || localStorage.getItem("userid"),
          "TO_DATE": dayjs(new Date()).format('DD/MM/YYYY'),
          "PRICELOGIC": 'S',
        })
        .then((response) => {
          console.info(response);
        
          // if(response===401){setShowModal(true)}
          if(response && response.Success === "False"){
            setShowLodder(false)
            setHoldingData([])
          }
          if(response && response.Success === "True" && response.hasOwnProperty("Success Description")){
            let responseData = response["Success Description"]; 
            console.log(`data ${responseData}`);
            if (Array.isArray(responseData) && responseData.length > 0) {

      
              setShowLodder(false)
              setHoldingData(responseData);

            
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []); // Empty dependency array to fetch data only once on component mount



  return (
    <Box sx={{ p: 3, maxWidth: 741, mx: "auto" }}>
    {/* Show loader during initial load */}
    {showfnolodder ? (
      <MyfnoLodder canShow={showfnolodder}/>
    ) : fnostatus ? (
      // Show status-based UI if FNO status exists
      <Box>

        {fnostatus === "exceeded" && (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: "140px !important" }}>
            <Typography sx={{ textAlign: "center", fontWeight: "bold", fontSize: { xs: "16px", sm: "22px", md: "26px", lg: "30px" } }}>
                  You have submitted the F&O request three times, and all have been rejected. Please contact our support team at <span style={{ color: "#f3d45e", fontWeight: "bold" }}>info@tradeboss.co</span> for further assistance.
            </Typography>
          </Box>
        )}
        {fnostatus === "already_active" && (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: "140px !important" }}>
            <Typography sx={{ textAlign: "center", fontWeight: "bold", fontSize: { xs: "16px", sm: "22px", md: "26px", lg: "30px" } }}>
              Your Futures & Options (F&O) is already active! You can start trading right away.
            </Typography>
          </Box>
        )}
        
        {fnostatus === "pending" && (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: "140px !important" }}>
            <Typography sx={{ textAlign: "center", fontWeight: "bold", fontSize: { xs: "16px", sm: "22px", md: "26px", lg: "30px" } }}>
              Your Futures & Options activation is currently in progress. Please allow up to 24 hours for activation.
              <pre></pre>
              <span style={{ color: "#f3d45e" }}>status : pending</span>
            </Typography>
          </Box>
        )}
        
        {fnostatus === "success" && (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: "140px !important" }}>
            <Typography sx={{ textAlign: "center", fontWeight: "bold", fontSize: { xs: "16px", sm: "22px", md: "26px", lg: "30px" } }}>
              Your Futures & Options (F&O) account has been successfully activated. You can now start trading confidently.
              <pre></pre>
              <span style={{ color: "#f3d45e" }}>status : approved</span>
            </Typography>
          </Box>
        )}
        
        {fnostatus === "Initialized" && (
          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", mt: "100px !important", textAlign: "center", p: 2 }}>
            <Typography sx={{ fontWeight: "bold", fontSize: { xs: "16px", sm: "22px", md: "26px", lg: "30px" }, lineHeight: 1.5 }}>
             one money Initialized, complete the process, if already completed wait for some time.
            </Typography>
            <Box sx={{ color: "#f3d45e", fontWeight: "bold", fontSize: { xs: "14px", sm: "18px" }, p: "8px 16px", borderRadius: "8px", mt: 2 }}>
              Status: Initialized
            </Box>
          
            {!onemoneysuccess && <Button sx={{ mt: 2 }} onClick={handleReupload}>
              Re take
            </Button>}
          </Box>
        )}

         {fnostatus === "rejected" && (
          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", mt: "100px !important", textAlign: "center", p: 2 }}>
            <Typography sx={{ fontWeight: "bold", fontSize: { xs: "16px", sm: "22px", md: "26px", lg: "30px" }, lineHeight: 1.5 }}>
                  Unfortunately, your Futures & Options activation has been rejected. <br />
                  { display && (
                    <>
                      You have submitted the F&O request three times, and all have been rejected.
                      Please contact our support team at{" "}
                      <span style={{ color: "#f3d45e", fontWeight: "bold" }}>
                        info@tradeboss.co
                      </span>{" "}
                      for further assistance.
                    </>
                  )}
        
            </Typography>
         
                   {  
                      !display && 
                      <Button sx={{ mt: 2 }} onClick={handleReupload}>
                        Re upload
                      </Button>
                    }
                 
                <Box sx={{ color: "#f3d45e", fontWeight: "bold", fontSize: { xs: "14px", sm: "18px" }, p: "8px 16px", borderRadius: "8px", mt: 2 }}>
                  Status: Rejected
                </Box>
                {
                  !display && 
                <Typography sx={{ fontSize: { xs: "14px", sm: "18px" } }}>
                  <strong>Reason:</strong> {remark}
                </Typography>
               }
          </Box>
        )}
      </Box>
    ) : (
     // Show the form if no status (or if API check is disabled) (
            <>
              {/* Step 1: Proof Selection */}
              {step === 1 && (
                <>
                  <Typography
                    sx={{
                      fontFamily: "Cardium Medium !important",
                      fontSize: "24px !important",
                      "@media (max-width: 460px)": { fontSize: "18px !important" },
                    }}
                  >
                    Activate Future and Options
                  </Typography>

                  {/* Net Worth Input */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "start",
                      gap: 1,
                      mt: 3,
                      mb: 3,
                      width: "100% !important"
                    }}
                  >

                    <TextField
                      label="Enter Your Net Worth"
                      variant="outlined"
                      type="text"
                      inputMode="numeric"
                      sx={{
                        flex: 1,
                        width: "100% !important",
                        backgroundColor: "#241E41 !important",
                        borderRadius: "5px",
                        "@media (max-width: 460px)": { maxWidth: "100%" },
                      }}
                      value={networth}
                      onChange={(e) => {
                        const raw = e.target.value.replace(/[^\d]/g, ""); // Remove non-digits
                        const formatted = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas
                        setNetworth(formatted);
                      }}
                      error={!!netErr}
                    />

                    {netErr && (
                      <span
                        style={{
                          color: "#FF0000",
                          fontSize: "12px",
                        }}
                      >
                        {netErr}
                      </span>
                    )}



                  </Box>

                  <Typography
                    sx={{ fontFamily: "Cardium B", fontSize: "15px", mt: 2 }}
                  >
                    Please submit any of the below proof for activating FNO
                  </Typography>

                   {usernetAssets >= 150 && <Box
                    sx={{
                      mt: 2,
                      p: 2,
                      backgroundColor: "#241E41 !important",
                      borderRadius: 2,
                      cursor: "pointer"
                    }}
                    onClick={() => handleCheckboxChange("Holdings_Statement")}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedOption === "Holdings_Statement"}
                          onChange={() => handleCheckboxChange("Holdings_Statement")}
                        />
                      }
                      label="Use my holdings statement as income proof"
                    />
                    <Typography
                      sx={{
                        ml: 4,
                        fontSize: {
                          xs: '12px',   // for small screens (mobile)
                          sm: '13px',   // small devices
                          md: '14px',   // medium devices and up
                        },
                      }}
                    >
                      Your holdings statement as on {
                        new Date(Date.now() - 86400000).toISOString().split('T')[0]
                      } will be used as income proof.
                    </Typography>
             
                  </Box>
                  }


                  {/* Bank Statement (Always Visible) */}
                  <Box
                    sx={{
                      mt: 2,
                      p: 2,
                      backgroundColor: "#241E41 !important",
                      borderRadius: 2,
                      cursor: "pointer"
                    }}
                    onClick={() => handleCheckboxChange("Bank_Statement")}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedOption === "Bank_Statement"}
                          onChange={() => handleCheckboxChange("Bank_Statement")}
                        />
                      }
                      label="Bank Statement"
                    />
                    {selectedOption === "Bank_Statement" && (
                      <Box
                        component="ul"
                        sx={{
                          pl: 7,
                          mt: 1,
                          listStyleType: "disc",

                          // Responsive styles
                          "@media (max-width: 700px)": {
                            paddingLeft: 6, // Reduce indentation for smaller screens
                            fontSize: "14px", // Smaller font
                          },

                          "@media (max-width: 480px)": {
                            paddingLeft: 5,
                            fontSize: "13px",
                          },
                        }}
                      >
                        {optionDetails.Bank_Statement.map((point, index) => (
                          <Box
                            component="li"
                            key={index}
                            sx={{
                              fontSize: "14px",
                              color: "#fff",

                              // Responsive styles for list items
                              "@media (max-width: 700px)": {
                                fontSize: "12px",
                              },

                              "@media (max-width: 450px)": {
                                fontSize: "11px",
                              },
                            }}
                          >
                            {point}
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                  <Box sx={{ mt: 2 }}>
                    <Typography
                      component="span"
                      onClick={() => setShowOtherDocuments(!showOtherDocuments)}
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 1,
                        color: selectedOption !== "Bank_Statement" ? "#f3d45e" : "#fff",
                        cursor: "pointer",
                      }}
                    >
                      Or, show other eligible documents
                      {showOtherDocuments ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </Typography>
                  </Box>

                  {/* Other Documents */}
                  {showOtherDocuments && (
                    <>
                      {[
                        { name: "Net_Worth", label: "Net Worth Certificate" },
                        { name: "Demat_Statement", label: "DP Holding Statement" },
                        { name: "ITR", label: "IT Return (Last Year)" },
                        { name: "Salary_Slip", label: "Salary Slip (Last Month)" },
                        { name: "Form_16", label: "Form 16B (Latest year)" }
                      ].map((item) => (
                        <Box
                          key={item.name}
                          sx={{
                            mt: 2,
                            p: 2,
                            backgroundColor: "#241E41 !important",
                            borderRadius: 2,
                            cursor: "pointer"
                          }}
                          onClick={() => handleCheckboxChange(item.name)}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedOption === item.name}
                                onChange={() => handleCheckboxChange(item.name)}
                              />
                            }
                            label={item.label}
                          />
                          {selectedOption === item.name && (
                            <Box sx={{ pl: 4, mt: 1 }}>
                              <Box
                                component="ul"
                                sx={{
                                  pl: 3, // Default padding left
                                  mt: 1,
                                  listStyleType: "disc",
                                  margin: 0, // Keep margin consistent

                                  // Responsive styles
                                  "@media (max-width: 700px)": {
                                    pl: 2, // Reduce indentation for smaller screens
                                    fontSize: "14px", // Smaller font
                                  },

                                  "@media (max-width: 480px)": {
                                    pl: 1,
                                    fontSize: "13px",
                                  },
                                }}
                              >
                                {optionDetails[item.name].map((point, index) => (
                                  <Box
                                    component="li"
                                    key={index}
                                    sx={{
                                      fontSize: "14px",
                                      color: "#fff",

                                      // Responsive styles for list items
                                      "@media (max-width: 700px)": {
                                        fontSize: "12px",
                                      },

                                      "@media (max-width: 450px)": {
                                        fontSize: "11px",
                                      },
                                    }}
                                  >
                                    {point}
                                  </Box>
                                ))}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      ))}
                    </>
                  )}

                  <Typography
                    sx={{
                      fontFamily: "Cardium B",
                      fontSize: "13px",
                      mt: 4,
                      textAlign: "left",
                      // Responsive media queries
                      '@media (max-width: 1200px)': {
                        fontSize: '14px', // Adjust font size for medium screens
                      },
                      '@media (max-width: 900px)': {
                        fontSize: '12px', // Adjust font size for smaller screens
                        mt: 3, // Adjust margin-top
                      },
                      '@media (max-width: 600px)': {
                        fontSize: '11px', // Smaller font size for mobile
                        mt: 2, // Adjust margin-top
                      },
                    }}
                  >
                    As per SEBI & Exchange regulations, you are required to
                    share your proof of income to enable trading in Futures &
                    Options.
                  </Typography>
                   <Typography
                    sx={{
                      fontFamily: "Cardium B",
                      fontSize: "13px",
                      mt: 2,
                      textAlign: "left",
                      // Responsive media queries
                      '@media (max-width: 1200px)': {
                        fontSize: '14px', // Adjust font size for medium screens
                      },
                      '@media (max-width: 900px)': {
                        fontSize: '12px', // Adjust font size for smaller screens
                        mt: 3, // Adjust margin-top
                      },
                      '@media (max-width: 600px)': {
                        fontSize: '11px', // Smaller font size for mobile
                        mt: 2, // Adjust margin-top
                      },
                    }}
                  >
                    I understand that trading in derivatives (futures & options) is inherently risky, and may result in loss of capital. I confirm I have gone through & understood the Risk Disclosure Documents explaining this.
                  </Typography>


                  {/* Proceed Button (Aligned to Right) */}
                  <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
                    {selectedOption === "Holdings_Statement" ? <Button
                      variant="contained"
                      onClick={handleSubmitHS}
                      sx={{
                        width: "300px !important",
                        fontFamily: "Cardium Medium !important",
                        height: "40px !important",

                      }}
                    >
                     Submit
                    </Button> :
                    <Button
                      variant="contained"
                      onClick={handleProceed}
                       sx={{
                        width: "300px !important",
                        fontFamily: "Cardium Medium !important",
                        height: "40px !important",

                      }}

                    >
                      Proceed to Next
                    </Button>
                  }
                  </Box>

                </>
              )}

              {/* Step 2: File Upload */}
              {step === 2 && (
                <>
                  <Typography
                    sx={{
                      fontFamily: "Cardium Medium !important",
                      fontSize: { xs: "18px", sm: "22px", md: "28px", lg: "34px" }, // Responsive font sizes
                      textAlign: "center !important",
                    }}
                  >
                    Upload{" "}
                    {[
                      { name: "Bank_Statement", label: "Bank Statement" },
                      { name: "Net_Worth", label: "Net Worth Certificate" },
                      { name: "Demat_Statement", label: "DP Holding Statement" },
                      { name: "ITR", label: "IT Return (Last Year)" },
                      { name: "Salary_Slip", label: "Salary Slip (Last Month)" },
                      { name: "Form_16", label: "Form 16B (Latest year)" }
                    ].find((item) => item.name === selectedOption)?.label ||
                      "Selected Proof"}
                  </Typography>

                  {/* Special Case: Bank Statement (Show Upload Methods) */}
                  {selectedOption === "Bank_Statement" ? (
                    <>
                      <Typography className={BSstyles.sub_text}>
                        As per the regulatory requirements, we would need six months
                        bank statement of the applicant.
                      </Typography>

                      {/* Radio Selection */}
                      {/* Radio Selection (Centered) */}
                      {/* <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <RadioGroup
                          className={BSstyles.radio_group}
                          value={uploadMethod}
                          onChange={(e) => setUploadMethod(e.target.value)}
                        >
                          <FormControlLabel
                            value="manual"
                            control={<CustomRadio />}
                            label={
                              <Typography className={BSstyles.radioText}>
                                Upload Manually
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="digital"
                            control={<CustomRadio />}
                            label={
                              <Typography className={BSstyles.radioText}>
                                Digitally fetch your bank statement
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      </Box> */}

                      {/* Upload Box */}
                      {uploadMethod === "manual" ? (
                        <>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              position: "relative",
                              marginTop: "32px !important",
                              marginBottom: "5px !important"
                            }}
                          >
                            {/* File Upload Box */}

                            <FileUploader
                              multiple={false}
                              maxSize={"1mb"}
                              hoverTitle="rAI"
                              label="Upload or drop a file right here"
                              handleChange={(file) => {
                                HandleFile(file);
                              }}
                              name="file"
                            >
                              <Box className={BSstyles.upload_box}>
                                <Box
                                  sx={{
                                    height: "60px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography className={BSstyles.dragdropstyle}>
                                    Drag and Drop here /{" "}
                                    <span className={BSstyles.browse_text}>
                                      Browse File
                                    </span>
                                  </Typography>
                                </Box>
                              </Box>
                            </FileUploader>
                          </Box>
                          {(bankStatmentFileName || incorrectErr) && (
                            <Box
                              sx={{
                                display: "flex !important",
                                justifyContent: "center !important",
                                marginTop: "25px",
                              }}
                            >
                              <Grid
                                container
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-around",
                                  "@media only screen and (max-device-width: 899px)":
                                  {
                                    width: "90%",
                                  },
                                }}
                              >
                                <Grid item style={{ textAlign: "left" }}>
                                  <Grid2 className="desktopUpload">
                                    <Grid2
                                      style={{ width: "100%", textAlign: "center" }}
                                    >
                                      {bankStatmentFileName && (
                                        <Typography
                                          sx={{
                                            "@media only screen and (max-device-width: 460px)":
                                            {
                                              fontSize: "12px !important",
                                            },
                                          }}
                                        >
                                          {bankStatmentFileName}
                                        </Typography>
                                      )}
                                      {incorrectErr && (
                                        <Typography
                                          sx={{
                                            fontSize: "12px !important",
                                            color: "red !important",
                                          }}
                                        >
                                          {incorrectErr}
                                        </Typography>
                                      )}
                                    </Grid2>
                                  </Grid2>
                                </Grid>
                              </Grid>
                            </Box>
                          )}
                        </>
                      ) : (
                        <Box>
                          <Grid2 className={BSstyles.img_card}>
                            <img
                              src={omImg}
                              alt="omimg"
                              className={BSstyles.om_img}
                            ></img>
                          </Grid2>
                          <Grid2 sx={{ padding: "0px 30px !important" }}>
                            <Typography className={BSstyles.omtext}>
                              TradeBoss works with onemoney, on RBI registered
                              account aggregator to securly fetch your data. You
                              will be registered to the onemoney website to provide
                              consent
                            </Typography>
                          </Grid2>
                        </Box>
                      )}

                      {/* Buttons */}
                      <Box className={BSstyles.but_card}>
                        {uploadMethod === "manual" ? (
                          <>
                            <Button
                              className={BSstyles.backBtn}
                              onClick={() => handleBack()}
                            >
                              Back
                            </Button>
                            {validated ? <Button
                              className={BSstyles.con_button}
                              onClick={() => handleUpload()}
                            >
                              Upload
                            </Button> : <Button
                              className={BSstyles.grey_button}
                              onClick={() => handleUploadGrey()}

                            >
                              Upload
                            </Button>
                            }
                          </>
                        ) : (
                          <>
                            <Button
                              className={BSstyles.backBtn}
                              onClick={() => handleBack()}
                            >
                              Back
                            </Button>
                            <Button className={BSstyles.Acon_button} onClick={handleProceedOneMoney}>
                              Proceed
                            </Button>
                          </>
                        )}
                      </Box>

                      {/* Security Notice */}
                      <Typography
                        sx={{
                          fontFamily: "Cardium B",
                          fontSize: "13px",
                          mt: 4,
                          textAlign: "center",
                          // Responsive media queries
                          '@media (max-width: 1200px)': {
                            fontSize: '14px', // Adjust font size for medium screens
                          },
                          '@media (max-width: 900px)': {
                            fontSize: '12px', // Adjust font size for smaller screens
                            mt: 3, // Adjust margin-top
                          },
                          '@media (max-width: 600px)': {
                            fontSize: '11px', // Smaller font size for mobile
                            mt: 2, // Adjust margin-top
                          },
                        }}
                      >
                        As per SEBI & Exchange regulations, you are required to
                        share your proof of income to enable trading in Futures &
                        Options.
                      </Typography>
                    </>
                  ) : (
                    <>
                      {" "}
                      {/* File Uploader */}
                      <Typography className={BSstyles.sub_text}>
                        {[
                          {
                            name: "Bank_Statement",
                            statement:
                              " As per the regulatory requirements, we would need six months bank statement of the applicant ",
                          },
                          {
                            name: "Net_Worth",
                            statement:
                              "As per regulatory requirements, we need the latest month's demat account statement showing securities valued at more than ₹10,000.",
                          },
                          {
                            name: "Demat_Statement",
                            statement:
                              "As per regulatory requirements, we need the latest month's demat account statement showing securities valued at more than ₹10,000.",
                          },
                          {
                            name: "ITR",
                            statement:
                              "As per regulatory requirements, we need the ITR Acknowledgement for the last financial year and proof of a gross annual income exceeding ₹1,20,000 lacs.",
                          },
                          {
                            name: "Salary_Slip",
                            statement:
                              "As per regulatory requirements, the document should not be more than 2 months old and must show a gross monthly salary exceeding ₹10,000",
                          },
                          {
                            name: "Form_16",
                            statement:
                              "As per regulatory requirements, your full name and PAN number must be clearly visible, and the Form 16B should be from the latest assessment year.",
                          },
                        ].find((item) => item.name === selectedOption)?.statement ||
                          "Selected Proof"}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          marginTop: "32px !important",
                          marginBottom: "5px !important"
                        }}
                      >
                        {/* File Upload Box */}
                        <FileUploader
                          multiple={false}
                          maxSize={"1mb"}
                          hoverTitle="rAI"
                          label="Upload or drop a file right here"
                          handleChange={(file) => {
                            HandleFile(file);
                          }}
                          name="file"
                        >
                          <Box className={BSstyles.upload_box}>
                            <Box
                              sx={{
                                height: "60px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Typography className={BSstyles.dragdropstyle}>
                                Drag and Drop here /{" "}
                                <span className={BSstyles.browse_text}>
                                  Browse File
                                </span>
                              </Typography>
                            </Box>
                          </Box>
                        </FileUploader>
                      </Box>
                      {(bankStatmentFileName || incorrectErr) && (
                        <Box
                          sx={{
                            display: "flex !important",
                            justifyContent: "center !important",
                            marginTop: "25px",
                          }}
                        >
                          <Grid
                            container
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-around",
                              "@media only screen and (max-device-width: 899px)": {
                                width: "90%",
                              },
                            }}
                          >
                            <Grid item style={{ textAlign: "left" }}>
                              <Grid2 className="desktopUpload">
                                <Grid2
                                  style={{ width: "100%", textAlign: "center" }}
                                >
                                  {bankStatmentFileName && (
                                    <Typography
                                      sx={{
                                        "@media only screen and (max-device-width: 460px)":
                                        {
                                          fontSize: "12px !important",
                                        },
                                      }}
                                    >
                                      {bankStatmentFileName}
                                    </Typography>
                                  )}
                                  {incorrectErr && (
                                    <Typography
                                      sx={{
                                        fontSize: "12px !important",
                                        color: "red !important",
                                      }}
                                    >
                                      {incorrectErr}
                                    </Typography>
                                  )}
                                </Grid2>
                              </Grid2>
                            </Grid>
                          </Grid>
                        </Box>
                      )}
                      {/* Action Buttons */}
                      <Box className={BSstyles.but_card}>
                        <Button
                          className={BSstyles.backBtn}
                          onClick={() => handleBack()}
                        >
                          Back
                        </Button>
                        {bankStatmentFileName ? <Button
                          className={BSstyles.con_button}
                          onClick={() => handleUpload()}
                        >
                          Upload
                        </Button> : <Button
                          className={BSstyles.grey_button}
                          onClick={() => handleUploadGrey()}

                        >
                          Upload
                        </Button>
                        }
                      </Box>
                      <Typography
                        sx={{
                          fontFamily: "Cardium B",
                          fontSize: "13px",
                          mt: 4,
                          textAlign: "center",
                          // Responsive media queries
                          '@media (max-width: 1200px)': {
                            fontSize: '14px', // Adjust font size for medium screens
                          },
                          '@media (max-width: 900px)': {
                            fontSize: '12px', // Adjust font size for smaller screens
                            mt: 3, // Adjust margin-top
                          },
                          '@media (max-width: 600px)': {
                            fontSize: '11px', // Smaller font size for mobile
                            mt: 2, // Adjust margin-top
                          },
                        }}
                      >
                        As per SEBI & Exchange regulations, you are required to
                        share your proof of income to enable trading in Futures &
                        Options.
                      </Typography>

                    </>
                  )}
                </>
              )}
            </>
    )}

      <Modal open={open}>
        <Box className={BSstyles.pwdModal}>
          <Typography className={BSstyles.pwdTitle}>
            {" "}
            Enter Password{" "}
          </Typography>
          <Typography className={BSstyles.pwdBody}>
            Please Provide the password for the Encrypted bank statement file
            uploaded
          </Typography>
          <TextField
            label="Password"
            type="password"
            variant="standard"
            fullWidth
            sx={{
              input: { color: "#999 !important" }, // Ensures input text is visible
              label: { color: "#999 !important" }, // Ensures label is visible
              "& .MuiInput-underline:before": {
                borderBottom: "1px solid black !important", // Normal border color
              },
            }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {passwordEnterErr && (
            <Typography
              // className="upload_tit1"
              sx={{
                fontSize: "12px !important",
                color: "red !important",
              }}
            >
              {passwordEnterErr}
            </Typography>
          )}
          <Grid
            sx={{
              display: "flex !important",
              justifyContent: "flex-end !important",
              marginTop: "20px !important",
            }}
          >
            <Button className={BSstyles.cancelButton} onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              className={BSstyles.submitButton}
              onClick={() => handlePasswordSubmit(password)}
            >
              Submit
            </Button>
          </Grid>
        </Box>
      </Modal>

      <MyLodder canShow={showlodder} />

  </Box>
  );
}
